import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * Wrapper que renderiza markdown con estilo L2 Aetheris.
 */
export default function MD({ children, className = "" }) {
  if (!children) return null;
  return (
    <div className={`md-content ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: (p) => <h1 className="text-3xl font-display text-[#d4a843] mb-4 mt-2" {...p} />,
          h2: (p) => <h2 className="text-2xl font-display text-[#d4a843] mb-3 mt-4" {...p} />,
          h3: (p) => <h3 className="text-lg font-display text-[#d4a843] mb-2 mt-3" {...p} />,
          p:  (p) => <p className="text-[#b8b3a8] leading-relaxed mb-3" {...p} />,
          strong: (p) => <strong className="text-[#f0ebe0] font-semibold" {...p} />,
          em: (p) => <em className="text-[#d4a843] italic" {...p} />,
          a:  (p) => <a className="text-[#d4a843] underline hover:text-[#e0b860]" target="_blank" rel="noreferrer" {...p} />,
          ul: (p) => <ul className="list-disc list-inside text-[#b8b3a8] space-y-1 mb-3 ml-2" {...p} />,
          ol: (p) => <ol className="list-decimal list-inside text-[#b8b3a8] space-y-1 mb-3 ml-2" {...p} />,
          li: (p) => <li className="text-[#b8b3a8]" {...p} />,
          code: (p) => <code className="bg-black/40 text-[#d4a843] px-1.5 py-0.5 rounded text-sm font-mono" {...p} />,
          blockquote: (p) => <blockquote className="border-l-2 border-[#d4a843] pl-4 text-[#b8b3a8] italic my-3" {...p} />,
          hr: () => <hr className="border-[#3a3328] my-4" />,
          table: (p) => <table className="w-full text-sm my-3" {...p} />,
          th: (p) => <th className="text-left py-2 px-3 text-[#d4a843] border-b border-[#3a3328] uppercase text-xs tracking-wider" {...p} />,
          td: (p) => <td className="py-2 px-3 text-[#b8b3a8] border-b border-[#3a3328]/40" {...p} />,
        }}
      >
        {String(children)}
      </ReactMarkdown>
    </div>
  );
}
